import React from 'react'
import './Styles/nav.css'
import { products } from './Product'
var categories  = [];
products.map((item)=>{
  return categories.push(item.category);
})
 const duplicate = new Set(categories);
 categories=[...duplicate];
function Nav({setcontent}) {
  return (
    <>
<div className="nav1" id="nav1">
    {categories.map((item,index)=>{
      const updatedcontent =()=>{
  setcontent(products.filter((fil)=>fil.category === item))
}
        return <div key={index} className='nav1t' onClick={updatedcontent}>{item}</div>
    })}
</div>
    </>
  )
}

export default Nav
